import { render } from "./patientShareTemplate.vue?vue&type=template&id=d277a81a"
import script from "./patientShareTemplate.vue?vue&type=script&lang=js"
export * from "./patientShareTemplate.vue?vue&type=script&lang=js"

import "./patientShareTemplate.vue?vue&type=style&index=0&id=d277a81a&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__